import { InfoOutlined } from '@mui/icons-material'
import { Box, Card, CardContent, CardHeader, Divider, Grid, Tooltip, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useOrder } from '../../OrdrContextProvider'

export default function FeesCard({ selectedCompany }) {
    const { t } = useTranslation()
    const orderContext = useOrder();

    // const showNoAdditionalCharge = () => {
    //     let price = selectedCompany?.price
    //     if (orderContext?.order?.otoIntegration?.paymentMethod === 'cod') {
    //         price = Number(price) - Number(selectedCompany?.codCharge)
    //     }
    //     return selectedCompany?.returnFee === price
    // }


    const getReturnToOrigin = () => {
        const price = Number(selectedCompany?.price) - Number(selectedCompany?.returnFee)
        const currency = selectedCompany?.currency

        if (price === 0) {
            return t('No additional charge')
        } else if (price > 0) {
            return t('shippingDetails.fees.returnToOriginInfoRefundPrice', { amount: price?.toFixed(2), currency: t(`currency.${currency}`) })
        } else {
            return t('shippingDetails.fees.returnToOriginInfoDeductPrice', { amount: Math.abs(price)?.toFixed(2), currency: t(`currency.${currency}`) })
        }

    }

    return (
        <Card>
            <CardHeader title={t("shippingDetails.fees.title")} />
            <Divider />
            <CardContent>
                <Grid container spacing={2}>
                    {
                        !!selectedCompany?.extraWeightPerKg &&
                        <Grid item xs={12} sm={6}>
                            <Box display="flex" flexDirection="column">
                                <Box display="flex" alignItems="center" mb={1}>
                                    {!!selectedCompany?.maxFreeWeight &&
                                        <Typography fontWeight="bold" variant="body2" sx={{ color: "text.lighter" }}>
                                            {t("shippingDetails.fees.ExtraCharge", { value: selectedCompany?.maxFreeWeight })}
                                        </Typography>
                                    }
                                    <Tooltip title={t("shippingDetails.fees.ExtraChargeInfo")} placement='top'>
                                        <InfoOutlined sx={{ ml: 1, color: "text.lighter" }} fontSize="small" />
                                    </Tooltip>
                                </Box>
                                <Typography variant="subtitle2">
                                    {`${selectedCompany?.extraWeightPerKg} ${t(`currency.${selectedCompany?.currency}`)} ${t("per")} ${t('kg')}`}
                                </Typography>
                            </Box>
                        </Grid>
                    }
                    {
                        !!selectedCompany?.codCharge &&
                        <Grid item xs={12} sm={6}>
                            <Box display="flex" flexDirection="column">
                                <Box display="flex" alignItems="center" mb={1}>
                                    <Typography fontWeight="bold" variant="body2" sx={{ color: "text.lighter" }}>
                                        {t("shippingDetails.fees.COD")}
                                    </Typography>
                                    <Tooltip title={t("shippingDetails.fees.CODInfo")} placement='top'>
                                        <InfoOutlined sx={{ ml: 1, color: "text.lighter" }} fontSize="small" />
                                    </Tooltip>
                                </Box>
                                <Typography variant="subtitle2">
                                    {`${selectedCompany?.codCharge} ${t(`currency.${selectedCompany?.currency}`)}`}
                                </Typography>
                            </Box>
                        </Grid>
                    }
                    {
                        !!selectedCompany?.cardOnDeliveryPercentage &&
                        <Grid item xs={12} sm={6}>
                            <Box display="flex" flexDirection="column">
                                <Box display="flex" alignItems="center" mb={1}>
                                    <Typography fontWeight="bold" variant="body2" sx={{ color: "text.lighter" }}>
                                        {t("shippingDetails.fees.CODPercentage")}
                                    </Typography>
                                    <Tooltip title={t("shippingDetails.fees.CODPercentageInfo")} placement='top'>
                                        <InfoOutlined sx={{ ml: 1, color: "text.lighter" }} fontSize="small" />
                                    </Tooltip>
                                </Box>
                                <Typography variant="subtitle2">
                                    {selectedCompany?.cardOnDeliveryPercentage}
                                </Typography>
                            </Box>
                        </Grid>
                    }
                    <Grid item xs={12} sm={6}>
                        <Box display="flex" flexDirection="column">
                            <Box display="flex" alignItems="center" mb={1}>
                                <Typography fontWeight="bold" variant="body2" sx={{ color: "text.lighter" }}>
                                    {t("shippingDetails.fees.returnToOrigin")}
                                </Typography>
                                <Tooltip
                                    title={t("shippingDetails.fees.returnToOriginInfoPriceTooltip")}
                                    placement='top'
                                >
                                    <InfoOutlined sx={{ ml: 1, color: "text.lighter" }} fontSize="small" />
                                </Tooltip>
                            </Box>
                            <Typography variant="subtitle2">
                                {getReturnToOrigin()}
                            </Typography>
                        </Box>
                    </Grid>
                    {!!selectedCompany?.fuelSurcharge &&
                        <Grid item xs={12} sm={6}>
                            <Box display="flex" flexDirection="column">
                                <Box display="flex" alignItems="center" mb={1}>
                                    <Typography fontWeight="bold" variant="body2" sx={{ color: "text.lighter" }}>
                                        {t("shippingDetails.fuelSurcharge.title")}
                                    </Typography>
                                    <Tooltip
                                        title={t("shippingDetails.fuelSurcharge.infoTooltip")}
                                        placement='top'
                                    >
                                        <InfoOutlined sx={{ ml: 1, color: "text.lighter" }} fontSize="small" />
                                    </Tooltip>
                                </Box>
                                <Typography variant="subtitle2">
                                    {t("shippingDetails.fuelSurcharge.fuelPrice", { value: selectedCompany?.fuelSurcharge })}
                                </Typography>
                            </Box>
                        </Grid>}
                </Grid>
            </CardContent>
        </Card>
    )
}
